import React from 'react';
import TournamentBanner from '../../features/tournaments/components/tournamentBanner';
import AdsBanner from '../../features/advertisement/components/adsBanner';
import { OnlinePlayersLayout } from '../../features/lobby/component/onlinePlayersLayout/onlinePlayersLayout';
import LobbyChatLayout from '../../features/lobby/component/lobbyChatLayout/lobbyChatLayout';
import TableListLayout from '../../features/lobby/component/tableListLayout/tableListLayout';
import { TournamentsBtnLeave } from '../../features/tournaments/components/tournamentsHeader/tournamentsBtnLeave/tournamentsBtnLeave';
import ChallengeBanner from '@base/features/ladder/components/challenges/challengeBanner/challengeBanner';
import styles from '../styles/lobbyPage.module.scss';

function LobbyPage() {
  return (
    <div className={styles.lobby}>
      <div className={styles.tournamentBanner}>
        <TournamentsBtnLeave />
        <div style={{ marginRight: '1rem' }}>
          <ChallengeBanner />
        </div>
        <TournamentBanner />
      </div>
      <div className={styles.adsBanner}>
        <AdsBanner />
      </div>
      <div className={styles.tables}>
        <TableListLayout />
      </div>
      <div className={styles.onlinePlayers}>
        <OnlinePlayersLayout />
      </div>
      <div className={styles.chat}>
        <LobbyChatLayout />
      </div>
    </div>
  );
}

export default LobbyPage;
